import React from 'react';
import Message from '../../../components/common/Message';
import trackingActions, {EVENT_ACTION, EVENT_CATEGORY} from '../../../actions/tracking.actions';
import taxActions from '../../../actions/tax.actions';
import FormsyForm from 'epic-diesel-form/src/components/external/FormsyForm';
import {Button, buttonTypes, priority} from 'epic-diesel-common/src';
import {getLocale} from 'epic-common/src/locale';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../..';
import {selectTaxSubmitted, selectTaxConsent} from '../../../selectors';

//@ts-ignore
import styles from './ConsentSection.pcss';

export interface ConsentProps {
    rejectedInVBucks?: boolean;
}

const ConsentSection = ({rejectedInVBucks}) => {
    const dispatch = useDispatch();

    const taxState = useSelector<RootState, {submitted: boolean; isConsent: boolean}>(state => ({
        submitted: selectTaxSubmitted(state),
        isConsent: selectTaxConsent(state)
    }));

    if (!taxState.submitted || taxState.isConsent || rejectedInVBucks) {
        return null;
    }

    const submitForm = () => {
        const locale = getLocale();
        dispatch(taxActions.consentForPayment({locale}));
        dispatch(
            trackingActions.trackClickEvent(
                EVENT_CATEGORY.TaxIdentity,
                EVENT_ACTION.ClickConsentLink
            )
        );
    };

    return (
        <div className={styles.section}>
            <div className={styles.title}>
                <Message code="epic.affiliate.common.submit.consent" />
            </div>
            <div className={styles.desc}>
                <Message code="label.affiliate.form.tax.consent.desc" />
            </div>
            <FormsyForm submitForm={submitForm}>
                <div className={styles.row}>
                    <Button type={buttonTypes.SUBMIT} priority={priority.PRIMARY} theme="dark">
                        <Message code="epic.affiliate.common.submit.consent" />
                    </Button>
                </div>
            </FormsyForm>
        </div>
    );
};

export default ConsentSection;
